module.exports = __webpack_public_path__ + "img/certs-no-bg.89e434f0.png";